import http from "../../http";

const BASE = "/resident/api/resident/houseBillAutoSchedule";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  runNow(r) {
    return http.tip.post(`${BASE}/runNow`, r);
  },
};
